
export function toPlainText(blocks) {
  if (!blocks) return '<Feed me your content!>'
  return blocks
    .map(block => {
      if (block._type !== 'block') {
        return '';
      }
      return block.children.map(child => child.text).join('');
    })
    .join('\n\n');
}

